import { Header } from "../Shared.styled"
import { Blur, Summary } from "./OrderSummary.styled"
import { Item, Label, Value } from "../../../../Ui/List/List"
import CopyButton from "../../../../Ui/CopyButton"

export const OrderLoadingSkeleton = () => (
  <Blur>
    <Header>
      <h2>Order: #1234567</h2>
    </Header>
    <Summary>
      <Item flexibleHeight>
        <Label>E-mail:</Label>
        <Value>
          <>
            john.doe@email.com
            <CopyButton string={""} />
          </>
        </Value>
      </Item>
      <Item>
        <Label>Store group:</Label>
        <Value>store group</Value>
      </Item>
      <Item>
        <Label>Store market:</Label>
        <Value flex>
          <>Sweden</>
        </Value>
      </Item>
      <Item>
        <Label>Order date:</Label>
        <Value>2000-00-00 00:00</Value>
      </Item>
      <Item>
        <Label>Total order value:</Label>
        <Value>SEK 200.00</Value>
      </Item>
    </Summary>
  </Blur>
)
